export const caseKeys = {
  all: ["cases"] as const,
  lists: () => [...caseKeys.all, "list"] as const,
  detail: (id: string) => [...caseKeys.all, "detail", id] as const,
} as const;
